import React, { useMemo } from "react"
import Menu from "../Menu/Menu"
import { HeaderTypes, ItemsProps } from "../Header"
import { graphql, useStaticQuery } from "gatsby"
import { ItemType } from "../Menu/MenuGroup/MenuGroup"

enum RoleTypes {
  CUSTOMER = "customer",
  EMPLOYEE = "employee",
}

export type RolesQuery = {
  allRolesJson: {
    edges: Array<{ node: ItemType }>
  }
}

const RolesMenu = ({ showOptions, handleToggleOptions }: ItemsProps) => {
  const data = useStaticQuery<RolesQuery>(RoleMenuItemsQuery)

  // Organize Customer and Employee
  const roleItems = useMemo(() => {
    const edges = data.allRolesJson.edges.map(e => e.node)
    if (!edges) return { customer: [], employee: [] }
    return {
      [RoleTypes.CUSTOMER]: edges.filter(n => n.type === RoleTypes.CUSTOMER),
      [RoleTypes.EMPLOYEE]: edges.filter(n => n.type === RoleTypes.EMPLOYEE),
    }
  }, [data.allRolesJson.edges])
  return (
    <Menu
      title={HeaderTypes.ROLES}
      items={roleItems}
      showOptions={showOptions}
      handleToggleOptions={handleToggleOptions}
    />
  )
}

export default RolesMenu

const RoleMenuItemsQuery = graphql`
  query RoleMenuItemsQuery {
    allRolesJson {
      edges {
        node {
          name
          slug
          type
        }
      }
    }
  }
`
